
export default {
  data() {
    return {
      inView: false,
      options: [
        {
          name: "bg",
          label: "Blue background",
          type: "checkbox",
        },
        {
          name: "title",
          label: "Title",
          type: "text",
        },
        {
          name: "description",
          label: "Description",
          type: "tipTap",
        },
      ],
    };
  },
};
